var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationPreviousIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.994,
    height: 17.162,
    viewBox: "0 0 11.994 17.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M1811.182,4362.342l-7.567,6.731,7.567,6.2",
    transform: "translate(-1801.306 -4360.224)",
    fill: "none",
    stroke: "#e8b03e",
    strokeLinecap: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationPreviousIcon);
export default __webpack_public_path__ + "static/media/pagination-previous-icon.4375e4e7365b6c88c21b3d18bb978d56.svg";
export { ForwardRef as ReactComponent };